export default function StatusMessage({ title, children }) {
  return (
    <div className="status-message">
      <h2>{title}</h2>
      {children && <p>{children}</p>}
    </div>
  );
}
